import { Browser } from '@capacitor/browser';
import { Stack } from '@mui/material';

import NoBillAccountIcon from '@/assets/icons/NoBillAccount';
import Button from '@/components/Button';
import Config from '@/config';
import Text from '@/elements/Text';
import useAuth from '@/hooks/useAuth';
import { Customer } from '@/types/graphql';
import { isWeb } from '@/util/platform';

interface Props {
  handleAddBilling: () => void;
  phoneOnly: boolean;
  customer: Customer;
}
const NoBillAccount = ({ handleAddBilling, phoneOnly, customer }: Props) => {
  const { currentAdminIsCustomerAdmin } = useAuth();
  const handleOpenBrowser = async () => {
    await Browser.open({
      url: currentAdminIsCustomerAdmin
        ? `${Config.BASE_URL}/my-company`
        : `${Config.BASE_URL}/clients/${customer.id}`,
    });
  };

  return (
    <Stack
      alignItems={'center'}
      direction={'column'}
      spacing={2.5}
      style={{
        width: phoneOnly ? '100%' : '80%',
        border: '1px solid #D3D3D3',
        padding: phoneOnly ? '16px' : '32px',
      }}
    >
      <NoBillAccountIcon style={{ width: '72px', height: '72px' }} />
      <Text>You have not setup a billing account yet.</Text>
      {isWeb() ? (
        <Button
          a11yLabel="add bill account"
          id="continue-btn"
          label="Add Billing Account"
          onClick={handleAddBilling}
        />
      ) : (
        <>
          <Text textAlignProp={'center'}>
            You need to add your billing account from the GravyWork web portal.
          </Text>
          <Button
            a11yLabel="Open in Browser"
            id="browser-btn"
            label="Open in Browser"
            onClick={handleOpenBrowser}
          />
        </>
      )}
    </Stack>
  );
};

export default NoBillAccount;
